import React, { MouseEventHandler, ReactNode, useState } from 'react';
import { TableThemeType } from './Table';

const TableRow = ({
  children,
  className,
  style,
  theme = 'dark',
}: {
  children?: ReactNode;
  className?: string;
  style?: any;
  theme?: TableThemeType;
}): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter: MouseEventHandler = () => {
    setIsHovered(true);
  };
  const handleMouseLeave: MouseEventHandler = () => {
    setIsHovered(false);
  };
  let hoverStyle;
  if (isHovered) {
    hoverStyle = {
      backgroundColor: (theme === 'light') ? 'rgba(0,0,0,0.125)' : 'rgba(255,255,255,0.25)',
    };
  } else {
    hoverStyle = {
      backgroundColor: 'transparent',
    };
  }
  return (
    <tr
      className={className}
      style={{
        ...hoverStyle,
        ...style,
        height: '3rem',
        transition: 'background 0.25s 0.125s ease-in-out',
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </tr>
  );
};

export default TableRow;
